import { SITE_HG, COUNTRY } from '@/config';

const OPEN_CLAW_URL_BY_BRAND = {
  br: `${SITE_HG}/servidor-vps/openclaw `,
  cl: `${SITE_HG}/vps-hosting/openclaw`,
  co: `${SITE_HG}/vps-hosting/openclaw`,
  mx: `${SITE_HG}/vps-hosting/openclaw`,
  ar: `${SITE_HG}/vps-hosting/openclaw`,
  pe: `${SITE_HG}/vps-hosting/openclaw`,
  bo: `${SITE_HG}/vps-hosting/openclaw`,
  cr: `${SITE_HG}/vps-hosting/openclaw`,
  do: `${SITE_HG}/vps-hosting/openclaw`,
  ec: `${SITE_HG}/vps-hosting/openclaw`,
  sv: `${SITE_HG}/vps-hosting/openclaw`,
  pa: `${SITE_HG}/vps-hosting/openclaw`,
  py: `${SITE_HG}/vps-hosting/openclaw`,
  uy: `${SITE_HG}/vps-hosting/openclaw`,
};

export const OPEN_CLAW_URL = OPEN_CLAW_URL_BY_BRAND[COUNTRY];
